export default {"src":"/_next/static/media/404-dark.dfc504f7.svg","height":251,"width":500,"blurWidth":0,"blurHeight":0};